import actionTypes from '../actionTypes';

const initialState = {
  step: 'product-type',
  fields: {
    type: '',
    name: '',
    subtype: '',
    soundRecordingType: '',
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CREATE_RESET_ATTRIBUTE:
      return { ...initialState };

    case actionTypes.CREATE_MOVE_STEP:
      return { ...state, step: action.step };

    case actionTypes.CREATE_ASSIGN_ATTRIBUTE:
      return {
        ...state,
        fields: { ...state.fields, [action.field]: action.attribute },
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/redux/reducers/create.js